/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IErrorModel, IPaymentOfferModel } from "../../models";
import * as Consts from "./consts";
import * as Types from "./types";

export const getOffers = (): Types.IGetOffersAction => {
  return {
    type: Consts.GET_OFFERS,
  };
};

export const getOffersSuccess = (
  offers: IPaymentOfferModel[]
): Types.IGetOffersSuccessAction => {
  return {
    type: Consts.GET_OFFERS_SUCCESS,
    payload: { offers },
  };
};

export const getOffersFailure = (
  error?: IErrorModel
): Types.IGetOffersErrorAction => {
  return {
    error,
    type: Consts.GET_OFFERS_FAILURE,
  };
};

export const PaymentActions = {
  getOffers,
  getOffersSuccess,
  getOffersFailure,
};
